import Fetch from "@/fetch/index";
//State
const state = {};

//Getters
const getters = {};

//Actions
const actions = {
  loadCustomerById(context, obj) {
    const id = obj.customerId;

    return new Promise((resolve, reject) => {
      Fetch.get(`/api/v1/customers/${id}`)
        .then((response) => {
          const data = response.data;

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

//Mutations
const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
